import React from 'react';
import './CustomMessage.css';
import { useAvatar } from '../../hooks/useAvatar';
import AvatarWomen from '../../assets/images/avatar-women.png';
import AvatarMen from '../../assets/images/avatar-men.png';
interface ToolTipMessage {
	background: string;
	textMessage: string;
	width?: string;
}

function CustomMessage({ background, width, textMessage }: ToolTipMessage) {
	const avatar = useAvatar();
	return (
		<div className="exporter-test-information__container-footer">
			<div className="exporter-test-information__svg-icon-text-footern">
				<img
					className="rounded-circle"
					src={avatar === 'women' ? AvatarWomen : AvatarMen}
					alt={avatar === 'women' ? 'avatar women' : 'avatar men'}
					width={24}
					height={24}
				/>
			</div>
			<div
				className="globo_mensaje_cubicaje rounded"
				style={{ backgroundColor: background, width: width }}>
				<span className="exporter-test-information__text-footer">{textMessage}</span>
			</div>
		</div>
	);
}

export default CustomMessage;
